<header class="header-theme">
  <div class="header-top"></div>
  <div *ngIf="user$ | async as user; else login">
    <div class="row d-flex justify-content-center align-items-center header-bar">
      <cx-page-slot position="PreHeader"></cx-page-slot>
      <cx-page-slot position="SiteLogo"></cx-page-slot>
      <cx-page-slot position="SearchBox"></cx-page-slot>
      <cx-page-slot position="HeaderLinks"></cx-page-slot>
      <cx-page-slot position="MiniCart" class="d-flex"></cx-page-slot>
      <cx-page-slot position="Wishlist" class="d-flex"></cx-page-slot>
    </div>
    <cx-page-slot position="NavigationBar"></cx-page-slot>
  </div>
</header>
<ng-template #login>
  <div class="row align-items-center header-bar header-icon">
    <cx-page-slot position="SiteLogo"></cx-page-slot>
  </div>
</ng-template>